import { DBv2, Table } from "@kosmod/pancake/kitchen";
import { Scene, SceneID, TerrainCanvasID, TerrainChunk, TerrainChunkList } from "./scene";
import { GameID } from "@kosmod/sesame";
import { Mini, MiniID, MiniTemplate, MiniTemplateID } from "./mini";
import { s, Shape } from "@kosmod/pancake";
import { DiceTemplate, DiceTemplateID } from "@kosmod/andy";
import { TerrainBrush } from "./terrainBrush";
import { MiniModel, MiniSprite } from "./miniRender";
import { ID } from "@kosmod/kit";

// export type TheatreDB = {
//   scenes: DBv2.Table<Omit<Scene, 'chunks'>, ['game', 'id']>,
  
//   minis: DBv2.Table<MiniTemplate, ['game', 'id']>,
//   minisByGame: DBv2.Index<MiniTemplate, ['game']>,

//   dice: DBv2.Table<DiceTemplate, ['game', 'id']>,
//   diceByGame: DBv2.Index<DiceTemplate, ['game']>,

//   brushes: DBv2.Table<TerrainBrush, ['game', 'id']>,
//   brushesByGame: DBv2.Index<TerrainBrush, ['game']>,

//   /**
//    * Chunk-based data is stored here.
//    */
//   chunks: DBv2.Table<TerrainChunkList, ['game', 'scene', 'canvas']>,
//   chunkByGame: DBv2.Index<TerrainChunkList, ['game']>,
//   chunkByScene: DBv2.Index<TerrainChunkList, ['game', 'scene']>,
// }

export const TheaterDB = DBv2.def({
  scenes: {
    name: 'theatre/scenes',
    primaryKeys: ['game', 'id'],
    shape: Scene,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },

  miniTemplates: {
    name: 'theatre/mini/templates',
    primaryKeys: ['game', 'id'],
    shape: MiniTemplate,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },
  miniSprites: {
    name: 'theatre/mini/sprites',
    primaryKeys: ['game', 'id'],
    shape: MiniSprite,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },
  miniModels: {
    name: 'theatre/mini/models',
    primaryKeys: ['game', 'id'],
    shape: MiniModel,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },

  diceTemplates: {
    name: 'theatre/dice',
    primaryKeys: ['game', 'id'],
    shape: DiceTemplate,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },

  chunkList: {
    name: 'theatre/terrain/chunks',
    primaryKeys: ['game', 'scene', 'canvas'],
    shape: TerrainChunkList,
    indices: {
      byGame: { indexKeys: ['game'] },
      byScene: { indexKeys: ['game', 'scene'] },
    }
  },
  brushes: {
    name: 'theatre/brushes',
    primaryKeys: ['game', 'id'],
    shape: TerrainBrush,
    indices: {
      byGame: { indexKeys: ['game'] }
    }
  },
})

export type TheatreDB = DBv2.OfDB<typeof TheaterDB>;